interface CursorPage<T> {
  results: T[];
  next?: string | null;
}

/** Table sorting/filtering must include every page, not only the newest 50 rows. */
export async function collectCursorPages<T>(getPage: (cursor?: string) => Promise<CursorPage<T>>): Promise<T[]> {
  const rows: T[] = [];
  const seen = new Set<string>();
  let cursor: string | undefined;
  for (;;) {
    const page = await getPage(cursor);
    rows.push(...page.results);
    if (!page.next) return rows;
    // Reuse only the cursor, not the supplied host; requests keep the typed endpoint and filters.
    const next = new URL(page.next, window.location.origin).searchParams.get('cursor');
    if (!next || seen.has(next)) throw new Error('Invalid pagination cursor');
    seen.add(next);
    cursor = next;
  }
}
